import React, {useState} from 'react'
import styled from 'styled-components'
import ReactSwitch from 'react-switch'

export type TumblerTypes = {
    className?: string,
    checked: boolean,
    changeHandler: () => void,
}

function Tumbler(props?: TumblerTypes) {

    const [layer, setLayer] = useState(false)

    const confirm = () => {
        setLayer(true)
    }

    const submit = () => {
        props.changeHandler()
        setLayer(false)
    }
    const cancel = () => {
        setLayer(false)
    }

    return (
        <StyledTumbler className={props.className}>

            {layer && (
                <div className="confirm">
                    <div className="info">Вы уверены?</div>
                    <div className="buttons">
                        <button onClick={cancel}>Нет</button>
                        <button onClick={submit}>Да</button>
                    </div>
                </div>)
            }

            <ReactSwitch
                checked={props.checked}
                onChange={confirm}
                handleDiameter={32}
                offColor='#e7e7e7'
                onColor='#2699FB'
                offHandleColor='#2699FB'
                onHandleColor='#FFFFFF'
                height={40}
                width={88}
                borderRadius={100}

                checkedIcon={
                    <div style={{
                        display: 'flex',
                        height: '100%',
                        fontSize: '12px',
                        fontFamily: 'Arial',
                        color: '#FFFFFF',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        ON
                    </div>
                }
                uncheckedIcon={
                    <div style={{
                        display: 'flex',
                        height: '100%',
                        fontSize: '12px',
                        fontFamily: 'Arial',
                        color: 'black',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        OFF
                    </div>
                }


                className='react-switch'
                id='small-radius-switch'
            />
        </StyledTumbler>
    )
}


const StyledTumbler = styled.div`
  .confirm {
    position: absolute;
    z-index: 1000;
    background: rgb(255, 255, 255);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    border-radius: 10px;

    .info {
      text-align: center;
      font-size: 25px;
      @media (max-width: 1100px) {
        font-size: 20px;
      }
    }

    .buttons {
      display: flex;
    }

    button {
      width: 70px;
      height: 40px;
      margin-top: 20px;
      @media (max-width: 1100px) {
        margin-top: 10px;
      }
    }
  }
@media (max-width: 1100px) {
  
}
`

export default Tumbler
